<div id="step5" appAppear (event)="onAppear()">
  <div class="contenu">

    <div class="leftImage">
      <app-picture src="assets/images/mockup_phone.png" alt="Kinomap Mockup Phone"></app-picture>
    </div>

    <div class="content">
      <!-- <h2><span [outerHTML]="'homepage.step5.titleHTML' | translate"></span></h2> -->
      <h2>{{ 'homepage.step5.titleHTML' | translate }}</h2>
      <div class="list">
        <div class="element" [ngClass]="animStart ? 'active' : '' ">
          <div class="picto">
            <img src="assets/images/svg/video_icon_grey.svg" alt="share_icon">
          </div>
          <div class="text">
            {{'homepage.step5.list.share' | translate}}
          </div>
        </div>
        <!-- assets/images/icons/interval_icon.svg -->
        <div class="element" [ngClass]="animStart ? 'active' : '' ">
          <div class="picto">
            <img src="assets/images/icons/share_icon.svg" alt="interval_icon">
          </div>
          <div class="text">{{'homepage.step5.list.interval' | translate}}</div>
        </div>

        <div class="element" [ngClass]="animStart ? 'active' : '' ">
          <div class="picto">
            <img src="assets/images/icons/interval_icon.svg" alt="lock_icon">
          </div>
          <div class="text">{{'homepage.step5.list.unblock' | translate}}</div>
        </div>

        <div class="element" [ngClass]="animStart ? 'active' : '' ">
          <div class="picto">
            <img src="assets/images/icons/multi_icon.svg" alt="multi_icon">
          </div>
          <div class="text">{{'homepage.step5.list.multi' | translate}}</div>
        </div>

        <div class="element" [ngClass]="animStart ? 'active' : '' ">
          <div class="picto">
            <img src="assets/images/icons/settings-display.svg" alt="flag_icon">
          </div>
          <div class="text">
            {{'homepage.step5.list.competition' | translate}}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
